var uuidToHash = function uuidToHash(id) {
  return id.slice(0, 8);
};

export default uuidToHash;